import { __rest } from 'tslib';
import React from 'react';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekIconButton = styled((_a) => {
    var props = __rest(_a, ["bordered", "size"]);
    return React.createElement(IconButton, Object.assign({}, props));
})(({ theme, size = "small", bordered = true }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.h5), { color: theme.palette.text.primary }), (bordered && {
    border: `${theme.spacing(0.05)} solid`,
})), (size !== "small" && {
    height: theme.spacing(3.7),
    minWidth: theme.spacing(3.9),
    [theme.breakpoints.down("md")]: {
        height: theme.spacing(4.2),
        minWidth: theme.spacing(4.4),
    },
})), { "&.MuiIconButton-colorInfo": Object.assign(Object.assign({ borderRadius: theme.spacing(0.8), padding: `0 ${theme.spacing(1)}`, backgroundColor: theme.palette.secondary.contrastText }, (bordered && {
        borderColor: theme.palette.grey[100],
    })), { ":hover": {
            borderColor: theme.palette.secondary.main,
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
        } }), "&.Mui-disabled": {
        opacity: 0.5,
        color: theme.palette.grey[400],
    } })));
const PeekContainedIconButton = styled(IconButton)(({ theme }) => (Object.assign(Object.assign({ boxShadow: "none", backgroundColor: theme.palette.secondary.light, color: theme.palette.text.primary }, theme.typography.body1), { "&:hover": {
        backgroundColor: theme.palette.secondary.light,
    }, "&.MuiIconButton-colorPrimary": {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
    }, "&.MuiIconButton-colorSecondary": {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
        "&:hover": {
            backgroundColor: theme.palette.secondary.main,
        },
    } })));

export { PeekContainedIconButton, PeekIconButton, PeekIconButton as default };
